function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Bills = function Bills(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M11.47 15.257c-1.504-.12-3.011-1.118-3.03-2.877 0-.41.33-.75.74-.76.41 0 .75.33.75.74.01 1.03 1.11 1.41 1.84 1.41.79 0 1.57-.05 1.98-.45.33-.31.4-.84.18-1.22-.29-.48-.94-.73-1.59-.93l-.86-.24c-1-.28-2.11-.67-2.71-1.67-.59-.98-.41-2.28.43-3.08.648-.62 1.546-.793 2.27-.841V4.83c0-.41.34-.75.75-.75s.75.34.75.75v.565c1.341.266 2.563 1.232 2.58 2.815 0 .41-.33.75-.74.76-.41 0-.75-.33-.75-.74-.01-.948-.941-1.345-1.659-1.403a.74.74 0 0 1-.385-.006c-.718.01-1.401.083-1.776.449-.33.31-.4.84-.18 1.22.32.53 1.08.78 1.83 1l.87.24c.91.27 1.91.67 2.46 1.6.59.98.41 2.27-.43 3.08-.52.496-1.198.706-1.82.795v.585c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM8.74 19.83h6.52c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8.74c-.41 0-.75.34-.75.75s.34.75.75.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M21.45 2.47h.8c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H1.75c-.41 0-.75.34-.75.75s.34.75.75.75h.8v17.77c0 1.54 1.25 2.79 2.79 2.79h13.32c1.54 0 2.79-1.25 2.79-2.79zm-1.5 0H4.05v17.77c0 .71.58 1.29 1.29 1.29h13.32c.71 0 1.29-.58 1.29-1.29z",
    clipRule: "evenodd"
  }));
};
export default Bills;
Bills.displayName = 'Bills';